import { getToken, setToken, removeToken, getUserId, setUserId, removeUserId } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    user: localStorage.getItem('__fh_user') ? JSON.parse(localStorage.getItem('__fh_user')) : null,
    userId: getUserId(),
    loginUserRoleName: localStorage.getItem('loginUserRoleName') ? localStorage.getItem('loginUserRoleName') : ''
  },

  mutations: {
    SET_LOGIN_USER_ROLE_NAME: (state, role) => {
      state.loginUserRoleName = role
      localStorage.setItem('loginUserRoleName', role)
    },
    SET_TOKEN: (state, token) => {
      state.token = token
      setToken(token)
    },
    SET_USER_ID: (state, id) => {
      state.userId = id
      setUserId(id)
    },
    SET_USER: (state, user) => {
      if (user === null || user === 'undefined') {
        state.userObj = null
        localStorage.setItem('__fh_user', '')
      } else {
        state.userObj = Object.assign({}, JSON.parse(JSON.stringify(user)))
        localStorage.setItem('__fh_user', JSON.stringify(user))
      }
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
  },

  actions: {
    // 登出
    LogOut({ commit }) {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      removeUserId()
      sessionStorage.clear()
      localStorage.clear()
    },
  }
}

export default user